import { MethodCommands, MethodProperties } from '@lentau/analytics/health-metrics/shared';
import { MethodPropertiesKey } from '../shared/consts';

export const COMMON_METHOD_PROPERTIES_LIST: MethodProperties = new Map([
  [
    'mainpageGet',
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.MI,
      },
    ],
  ],
  [
    'sessionGet',
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CL,
      },
    ],
  ],
  [
    'regionList',
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.GR,
      },
    ],
  ],
  [
    'deliveryModeGet',
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.GR,
      },
    ],
  ],
  [
    'storesPickupSearch',
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.GR,
      },
    ],
  ],
  [
    'userAddressSearch',
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.GR,
      },
    ],
  ],
  [
    'regionUser',
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.GR,
      },
    ],
  ],
  [
    'pageInfo',
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CL,
      },
    ],
  ],
  [
    'bannersAdhweb',
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CL,
      },
    ],
  ],
  [
    'pagesTypesWidgets',
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.MI,
      },
    ],
  ],
  [
    'pagesWidgets',
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.MI,
      },
    ],
  ],
]);
